import React from "react";
var AuthMenu = function AuthMenu(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    "aria-label": "Menu principale"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "sr-only"
  }, "Menu principale"), /*#__PURE__*/React.createElement("div", {
    className: "navbar navbar-expand-md py-1 px-md-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-brand d-block d-md-none"
  }, "Menu"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "navbar-toggler toggler-animate collapsed p-0",
    "data-target": "#menu-top",
    "data-toggle": "collapse",
    "aria-expanded": "false"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Apri menu principale"), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-bars fa-lg"
  })), /*#__PURE__*/React.createElement("div", {
    className: "collapse navbar-collapse",
    id: "menu-top"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "navbar-nav d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/che-cosa-e" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/che-cosa-e"
  }, "Che cosa \xE8"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/a-cosa-serve" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/a-cosa-serve"
  }, "A cosa serve"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/certificazione" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/certificazione"
  }, "Come ottenere la certificazione"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/contributi" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/contributi"
  }, "Contributi"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/organismi-di-certificazione" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/organismi-di-certificazione"
  }, "Organismi di certificazione"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/news" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/news"
  }, "Notizie"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/numeri" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/numeri"
  }, "Numeri"))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item text-md-center"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
    target: "_self",
    className: "nav-link ".concat(window.location.pathname == process.env.CONTEXT_PATH + "/faq" ? "active" : ""),
    href: process.env.CONTEXT_PATH + "/faq"
  }, "FAQ")))))))));
};
export default AuthMenu;